var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.883 0.00699997L9 0C9.24493 3.23106e-05 9.48134 0.0899562 9.66437 0.252715C9.84741 0.415475 9.96434 0.639749 9.993 0.883L10 1V8H17C17.2449 8.00003 17.4813 8.08996 17.6644 8.25272C17.8474 8.41547 17.9643 8.63975 17.993 8.883L18 9C18 9.24493 17.91 9.48134 17.7473 9.66437C17.5845 9.84741 17.3603 9.96434 17.117 9.993L17 10H10V17C9.99997 17.2449 9.91004 17.4813 9.74728 17.6644C9.58453 17.8474 9.36025 17.9643 9.117 17.993L9 18C8.75507 18 8.51866 17.91 8.33563 17.7473C8.15259 17.5845 8.03566 17.3603 8.007 17.117L8 17V10H1C0.755067 9.99997 0.518663 9.91004 0.335628 9.74728C0.152593 9.58453 0.0356572 9.36025 0.00699997 9.117L0 9C3.23106e-05 8.75507 0.0899562 8.51866 0.252715 8.33563C0.415475 8.15259 0.639749 8.03566 0.883 8.007L1 8H8V1C8.00003 0.755067 8.08996 0.518663 8.25272 0.335628C8.41547 0.152593 8.63975 0.0356572 8.883 0.00699997L9 0L8.883 0.00699997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.82b1cf62eb0b978636b666772dd23a67.svg";
export { ForwardRef as ReactComponent };